(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["goli-style-product-grid"] && !Shopify.designMode) return;
  try {
    
function openCartDrawer(detail){
  try {
    document.dispatchEvent(new CustomEvent('cart:open', { detail }));
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail }));
    document.dispatchEvent(new CustomEvent('theme:cart:open', { detail }));
    document.dispatchEvent(new CustomEvent('theme:cart:update', { detail }));
    document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail }));
  } catch(e){}
  try { if (window.theme?.CartDrawer?.open) { theme.CartDrawer.open(); bindCartClose(); return true; } } catch(e){}
  try { if (window.theme?.miniCart?.open) { theme.miniCart.open(); bindCartClose(); return true; } } catch(e){}
  try { if (window.CleanThemes?.MiniCart?.open) { CleanThemes.MiniCart.open(); bindCartClose(); return true; } } catch(e){}
  try { if (window.Clean?.Cart?.open) { Clean.Cart.open(); bindCartClose(); return true; } } catch(e){}
  try {
    const cd = document.querySelector('cart-drawer, cart-drawer-component');
    if (cd && typeof cd.open === 'function') { cd.open(); bindCartClose(); return true; }
    if (cd) { cd.setAttribute('open',''); bindCartClose(); return true; }
  } catch(e){}
  const toggleSelectors = [
    '[data-drawer-toggle="cart"]','[data-cart-toggle]','.js-mini-cart-trigger',
    '[data-action="open-mini-cart"]','button[aria-controls*="mini-cart"]','a[href="#mini-cart"]',
    '.drawer-toggle--cart','.header__cart, .site-header__cart, .cart-link, .mini-cart__toggle'
  ];
  for (const sel of toggleSelectors) {
    const el = document.querySelector(sel);
    if (el) { el.click(); bindCartClose(); return true; }
  }
  return false;
}
async function getCart(){ const r = await fetch('/cart.js', {headers:{'Accept':'application/json'}}); return r.json(); }
async function refreshCartDrawerUI(){
  try{
    const cart = await getCart();
    try { if (window.theme?.CartDrawer?.render) { theme.CartDrawer.render(cart); } } catch(e){}
    try { if (window.theme?.miniCart?.render) { theme.miniCart.render(cart); } } catch(e){}
    try { if (window.CleanThemes?.MiniCart?.render) { CleanThemes.MiniCart.render(cart); } } catch(e){}
    try {
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail:{cart} }));
      document.dispatchEvent(new CustomEvent('cart:updated', { detail:{cart} }));
      document.dispatchEvent(new CustomEvent('cart:change', { detail:{cart} }));
      document.dispatchEvent(new CustomEvent('ajaxCart.afterCartLoad', { detail:{cart} }));
      document.dispatchEvent(new CustomEvent('theme:cart:update', { detail:{cart} }));
    } catch(e){}
    const drawerCandidates = ['cart-drawer','cart-drawer-component','.mini-cart','.drawer--cart','.cart-drawer'];
    const dstSel = drawerCandidates.find(sel => document.querySelector(sel));
    if (dstSel){
      const dst = document.querySelector(dstSel);
      const html = await fetch(window.location.href, {headers:{'Accept':'text/html'}}).then(r=>r.text());
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const src = doc.querySelector(dstSel);
      if (dst && src && src.innerHTML.trim().length){
        dst.innerHTML = src.innerHTML;
        bindCartClose();
      }
    }
  }catch(e){}
}
function isDrawerOpen(){
  const candidates = [
    'cart-drawer[open]','cart-drawer-component[open]',
    'body.is-cart-open','.drawer--cart.is-open','.mini-cart.is-open','.is-mini-cart-open'
  ];
  return candidates.some(sel => document.querySelector(sel));
}
async function addLine(variantId, qty, sellingPlan){
  const fd = new FormData();
  fd.set('id', variantId);
  fd.set('quantity', String(qty||1));
  if(sellingPlan){ fd.set('selling_plan', sellingPlan); }
  const res = await fetch('/cart/add.js', { method:'POST', headers:{'Accept':'application/json'}, body: fd });
  if(!res.ok) throw new Error('Add failed');
  return res.json();
}
function bindCartClose(){
  if(window.__goliCloseBound) return;
  window.__goliCloseBound = true;
  const closeSelectors = '.cc-popup-close,[data-cc-popup-close],[data-drawer-close],[data-drawer-close="cart"],.drawer__close,.cart-drawer__close,.mini-cart__close,.js-mini-cart-close,[aria-label="Close"],[aria-label="Close cart"],[aria-label*="close" i]';
  function hardClose(){
    const nodes = document.querySelectorAll('dialog[open],#CartDrawer[open],cart-drawer[open],cart-drawer-component[open],.cart-drawer.is-open,.drawer--cart.is-open,.mini-cart.is-open,.cc-popup.is-open,[data-cc-popup].is-open');
    nodes.forEach(n=>{
      try{ if(n.nodeName==='DIALOG' && n.open) n.close(); }catch(e){}
      n.removeAttribute('open');
      n.classList.remove('is-open','is-active','is-visible','open');
      n.setAttribute('aria-hidden','true');
    });
    document.documentElement.classList.remove('js-drawer-open','has-popup-open','is-cart-open','is-mini-cart-open');
    document.body.classList.remove('js-drawer-open','has-popup-open','is-cart-open','is-mini-cart-open','overflow-hidden');
    try{ if(window.theme?.CartDrawer?.close) theme.CartDrawer.close(); }catch(e){}
    try{ if(window.theme?.miniCart?.close) theme.miniCart.close(); }catch(e){}
    try{ if(window.CleanThemes?.MiniCart?.close) CleanThemes.MiniCart.close(); }catch(e){}
    try{ if(window.Clean?.Cart?.close) Clean.Cart.close(); }catch(e){}
  }
  document.addEventListener('click',function(e){
    const btn = e.target.closest(closeSelectors);
    if(!btn) return;
    e.preventDefault();
    e.stopPropagation();
    hardClose();
  },true);
  document.addEventListener('keydown',function(e){ if(e.key==='Escape') hardClose(); },true);
}

document.addEventListener('click', (e) => {
  const tile = e.target.closest('.js-purchase-option');
  if(!tile) return;
  const wrap = tile.closest('.goli-right');
  if(!wrap) return;
  wrap.querySelectorAll('.js-purchase-option').forEach(el => el.classList.remove('is-active'));
  tile.classList.add('is-active');
  if (isDrawerOpen()){
    openCartDrawer({ reason:'selection' });
    refreshCartDrawerUI();
  }
});
document.addEventListener('submit', async (e) => {
  const form = e.target.closest('.js-goli-atc');
  if(!form) return;
  e.preventDefault();
  const right = form.closest('.goli-right');
  const active = right?.querySelector('.js-purchase-option.is-active');
  const mode = active?.dataset.mode || 'onetime';
  const variantId = right?.dataset.variantId;
  const planId = right?.dataset.planId || '';
  try {
    await addLine(variantId, 1, (mode === 'subscription' && planId) ? planId : null);
    openCartDrawer({ reason:'added' });
    setTimeout(refreshCartDrawerUI, 60);
  } catch(err){
    window.location.href = '/cart';
  }
}, { passive:false });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      theme.ProductBlockManager.loadImages(productRecommendationsSection);
      theme.initAnimateOnScroll();
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
